import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'components/buttons'
import { MenuButton } from 'components/buttons/MenuButton'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CorrectionAction } from 'types'

interface Props {
  onSelection: (action: CorrectionAction) => void
}

export const ActionDropdown: FC<Props> = ({ onSelection }) => {
  const { t } = useTranslation()

  const menuItems = [
    {
      label: t('features.correctionsQueue.markAsCompleted'),
      onClick: () => onSelection(CorrectionAction.Completed),
    },
    {
      label: t('features.correctionsQueue.markAsNotRequired'),
      onClick: () => onSelection(CorrectionAction.NotRequired),
    },
  ]

  return (
    <MenuButton
      button={({ menuHidden, toggleMenuHidden }) => (
        <Button onClick={toggleMenuHidden} variant="outlined">
          {t('features.correctionsQueue.selectAction')}
          <FontAwesomeIcon icon={menuHidden ? faChevronDown : faChevronUp} />
        </Button>
      )}
      menuItems={menuItems}
    />
  )
}

export default ActionDropdown
